import { useEffect, useState } from 'react';

/**
 * Rotates the site's wordmark between the two active brand identities:
 *   "SPRITE VAULT" ⇄ "FORT-VAULT"
 * Every `intervalMs` (default 10s) it flips. All consumers stay in sync
 * because we base the index on Date.now() rather than each component's
 * mount time, so headers in different parts of the tree don't drift.
 */
export const BRAND_WORDS = ['SPRITE VAULT', 'FORT-VAULT'];

export function useBrandWord(intervalMs = 10_000) {
  const initial = Math.floor(Date.now() / intervalMs) % BRAND_WORDS.length;
  const [idx, setIdx] = useState(initial);
  useEffect(() => {
    // realign to the global clock on mount, then tick every interval
    const align = () => setIdx(Math.floor(Date.now() / intervalMs) % BRAND_WORDS.length);
    align();
    const t = setInterval(align, intervalMs);
    return () => clearInterval(t);
  }, [intervalMs]);
  return BRAND_WORDS[idx];
}
